export type LanguageCode = 'tr' | 'en' | 'ru'

export type Language = {
  code: LanguageCode
  label: string
  shortLabel: string
  path: string
  locale: string
}

export const defaultLanguage: LanguageCode = 'tr'

export const languages: Language[] = [
  {
    code: 'tr',
    label: 'Türkçe',
    shortLabel: 'TR',
    path: '/tr/',
    locale: 'tr-TR',
  },
  {
    code: 'en',
    label: 'English',
    shortLabel: 'EN',
    path: '/en/',
    locale: 'en-GB',
  },
  {
    code: 'ru',
    label: 'Русский',
    shortLabel: 'RU',
    path: '/ru/',
    locale: 'ru-RU',
  },
]

export const getLanguageFromPath = (pathname: string): LanguageCode => {
  const segment = pathname.split('/').filter(Boolean)[0]

  if (segment === 'en' || segment === 'ru' || segment === 'tr') {
    return segment
  }

  return defaultLanguage
}

export const withLanguagePath = (language: LanguageCode, slug = '') => {
  const normalizedSlug = slug.replace(/^\/+/, '')
  return `/${language}/${normalizedSlug}`.replace(/\/?$/, '/')
}
